import * as S from "./ComingSoonItem.style"
import { ReactComponent as IconCommingSoon } from "@/styles/assets/svg/icon_comingsoon.svg";

export const ComingSoonItem = () => {
  return (
      <S.ComingSoonItem>
        <IconCommingSoon />
        <S.ComingSoonTit>
          <h4>Coming Soon!</h4>
          <span>서비스 준비중입니다.</span>
        </S.ComingSoonTit>
      </S.ComingSoonItem>
  );
};